import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import {BASE} from '../api/api'
import Axios from 'axios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import { List } from 'react-content-loader'
import grey from '../assets/annualreport.png'
import EventReport from '../events/evenReport';

class ResearchDivision extends Component {
    constructor(props) {
        super(props);
        this.state={
            resdiv:'',
            annual:'',
            annualcover:'',
            annualpdf:'',
            imagepast:''
        }
    
      }
      topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
       componentWillMount(){
         this.topFunction();

        //ResrchDiviison

        Axios(BASE+'jsonapi/node/page?filter[drupal_internal__nid]=31', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
        .then((data) => {

            this.setState({
                // hometitle:BASE+data.data.included[0].attributes.uri.url,
                resdiv:data.data.data[0].attributes.body.processed
            })
        })
        .catch((err) => {
            console.log('not found')
        })

        //Anuual reports cover

        Axios(BASE+'jsonapi/node/annual_reports?include=field_thumbnail', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                console.log(data.data,'annual')
                let i,j
                let imageup=[];
                let imagepast=[];
                this.setState({
                    annual:data.data.data,
                    annualcover:data.data.included
                })
                data.data.data.map((event,index)=>{
                    if(event.relationships.field_thumbnail.data!==null)
                {   
                    for(j=0;j<data.data.included.length;j++){
                    if(event.relationships.field_thumbnail.data.id===data.data.included[j].id){
                        imagepast.push(BASE+data.data.included[j].attributes.uri.url);
                                            
                    }
                
                }

            }
            else{
                imagepast.push(grey);
                     
            }

                })
                this.setState({
                    imagepast:imagepast,
                })
            })
            .catch((err) => {
                console.log('not found')
            })

       

        Axios(BASE+'jsonapi/node/annual_reports?include=field_file', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                console.log(data.data.included,'apiz')
                
                this.setState({
                    annualpdf:data.data.included
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
render() {


    
    return (
        <div className='articlepage researchdivpage'>
        <div className="page-title">
            <div className="title-wrapper">
                <div className="container">
                    <h1 className="heading">Research Division</h1>
                </div>
            </div>
        </div>
        <div className="main-content listing teamsection">
            <div className="container basicpage">
                <div className="row">
                <div className="region region-content">
                    <div className="listings">
                    {this.state.resdiv?ReactHtmlParser(this.state.resdiv):<List/>}

                    </div>
                </div>
                </div>
            </div>
        </div>
    {/* Annual Rerports */}
        {/* <div className="page-title">
            <div className="title-wrapper">
                <div className="container">
                    <h1 className="page-header">Annual Reports</h1>
                </div>
            </div>
        </div>
        <div className="main-content annualpdf">
        <div className="container">
          <div className="row">
            <div className="region region-content">
              <div className="view-wiki"> 

            {this.state.annualcover&&this.state.annualpdf&&this.state.imagepast?
              this.state.annualpdf.map((institute,index)=>{
                return(
                <div key={index} className="views-row col s6 m3 l3"> 
                <a target="_blank" rel="noopener noreferrer"  href={BASE+this.state.annualpdf[index].attributes.uri.url}>
                  <span className="field-content">
                    <div className="img-head">
                    
                        <img typeof="foaf:Image" src={this.state.imagepast[index]}  alt="" />
                    <div className='report-title'>{this.state.annual[index].attributes.title.substring(0, 30)}{this.state.annual[index].attributes.title.length > 30 ? '....' : ''}</div>
                    </div>
                    
                  </span> 
                  </a> 
                </div>)
              }):<List/>}

                  
              </div>
              
            </div>
          </div>
        </div>
      </div> */}
      {/* <EventReport/> */}
        </div>
            )
    
    
}

}


export default ResearchDivision;
